import { render, staticRenderFns } from "./salarydetails.vue?vue&type=template&id=162c3a1a&"
import script from "./salarydetails.vue?vue&type=script&lang=js&"
export * from "./salarydetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports